angular.module('ordersCancelReasons', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/orders-cancel-reasons/orders-cancel-reasons.module.js